<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{ cardTitle }}</h4>

            <p class="card-title-desc">
                {{ description }}
            </p>
            <div class="col-4 d-flex align-items-center">
                <b-form-input v-model="searchFilter" type="search" placeholder="Αναζητήστε Ονοματεπώνυμο ή Κάρτα"
                    @keyup.enter="onSearchPerson"></b-form-input>
                <b-input-group-append class="d-flex">
                    <b-button variant="primary" @click.prevent="onSearchPerson">
                        <i class="bx bx-search-alt-2"></i>
                    </b-button>
                    <b-button v-if="searchFilter.length > 0" variant="danger" @click.prevent="clearSearch">
                        <i class="bx bx-x"></i>
                    </b-button>

                </b-input-group-append>
            </div>
            <div class="justify-content-between col-12">
                <b-table :items="entity" :fields="tableFields">
                    <template #cell(checked)="row">
                        <b-form-radio v-model="supervisorId" :value="row.item.id" plain></b-form-radio>
                    </template>
                </b-table>
                <b-pagination v-model="currentPageModal" :total-rows="count" :per-page="perPage"
                    aria-controls="my-table" class="pagination pagination-rounded mb-0"></b-pagination>
                <b-button class="btn mt-2" variant="success"
                    @click="submitSelection(supervisorId)">Αποθήκευση</b-button>
            </div>
        </div>
    </div>
</template>

<script>
import session from "../../../../api/session";
export default {
    props: {
        modalId: String,
        cardTitle: String,
        description: String,
        detailedEntity: {
            type: Array,
            default: () => []
        },
    },
    components: {},
    data() {
        return {
            entity: [],
            // people: {},
            tableFields: [
                { key: 'checked', label: 'Επιλογή', sortable: false },
                { key: 'full_name', label: 'Ονοματεπώνυμο' },
                { key: 'person_card_number', label: 'Αριθμός Κάρτας' },
            ],
            currentPageModal: 1,
            perPage: 10,
            count: 0,

            supervisorId: null,
            searchFilter: ""
        }
    },
    computed: {
        selectedPeopleIds() {
            return Object.keys(this.selectedPeople)
                .filter(id => this.selectedPeople[id] && !isNaN(id))
                .map(Number);
        },
        selectedPeopleFullNames() {
            return this.entity
                .filter((person) => this.selectedPeople[person.id])
                .map((person) => person.full_name);
        },
        selectedPeopleCardNumber() {
            return this.entity
                .filter((person) => this.selectedPeople[person.id])
                .map((person) => person.person_card_number);
        }
    },
    watch: {
        currentPageModal() {
            this.fetchPeople();
        },
    },
    methods: {
        async fetchPeople() {
            let data = {
                page: this.currentPageModal,
                search: this.searchFilter
            }
            let urlparams = new URLSearchParams(data).toString();
            await session
                .get(`api/entity-group-outsiders/?${urlparams}`)
                .then((resp) => {
                    this.entity = resp.data.results
                        .map(person => ({
                            id: person.id,
                            full_name: person.person_full_name,
                            person_card_number: person.person_card_number
                        }));
                    this.count = resp.data.count;
                }).catch((e) => {
                    console.log(e.response.data);
                })
        },
        async submitSelection(supervisorId) {
            let data = {
                supervisor: supervisorId
            };

            await session
                .post(`api/entity-group/create/`, data)
                .then(() => {
                    this.fetchPeople();
                    this.$emit("fetchEntity");
                }).catch((e) => {
                    console.log(e.response.data);
                })
            this.closeModal();

        },
        closeModal() {
            this.$bvModal.hide("createSupervisorModal");
        },
        onSearchPerson() {
            this.currentPageModal = 1;
            this.fetchPeople();
        },
        clearSearch() {
            this.searchFilter = "";
            this.currentPageModal = 1;
            this.fetchPeople();
        }
    },
    mounted() {
        this.fetchPeople();
    }
};
</script>
